export default "__VITE_ASSET__3fbca9ce__"